<template lang='pug'>
  v-toolbar.elevation-0.main-nav(color='white' dark fixed app pa-0 style="z-index: 11;")
    v-img(:src="logoUrl" height="90%" contain position="left center")
    v-spacer
    .click.fill-height.main-menu-block(
      v-for="route in mainMenu"
      :key="route.to"
      @click="$router.push(route.to)"
      :class="$route.fullPath.startsWith(route.to) ? 'selected-menu-item primary white--text' : 'white black--text'"
    )
      v-layout.fill-height.align-center
        .subheading.pb-1.mx-4.main-menu-route {{ route.title }}
    .fill-height.main-menu-block.p-relative.click(v-if="this.$store.state.app.destination.id == 1" @click="toggle" :class="$route.fullPath.startsWith('/products') ? 'selected-menu-item primary white--text' : productsOpen ? 'product-open' : 'white black--text'" v-click-outside="close")
      v-layout.fill-height.align-center.ml-4.mr-3
        .subheading.pb-1.pr-2.main-menu-route PRODUITS
        v-icon.pb-2(v-if="productsOpen") expand_less
        v-icon.pb-2(v-else) expand_more
    v-layout.products-menu-block.main-sub-menu.black--text.white.justify-center.wrap(v-if="productsOpen && this.$store.state.app.destination.id == 1")
      .fill-height.main-menu-block.p-relative.click(
        v-for="category in productCategories"
        :key="category.id"
        @click="goToProduct(category.id)"
        :class="{ 'primary white--text': $route.fullPath.startsWith('/products') && $route.params.productId == category.id }"
      )
        v-layout.fill-height.align-center.py-3
          .subheading.pb-1.mx-4.main-menu-route {{ category.name }}
    v-spacer
    v-divider(vertical dark)
    v-toolbar-items
      v-menu.primary(key="logged" ref="navMenu" offset-y transition="slide-y-transition" content-class="main-menu-dropdown" data-test="user-menu")
        v-btn.pl-0.pr-3(large flat slot="activator")
          v-layout.align-center.row.justify-space-between.pl-5
            v-layout.align-start
              v-flex.text-truncate
                span.text-lowercase.subheading.font-weight-regular {{ user.login }}
            v-icon.px-3 settings
        v-list.menu-main-nav
          v-list-tile(
            v-for="(item, i) in items"
            :key="`'menu-main-nav-'${i}`"
            @click=""
            :to='item.to'
            )
            v-list-tile-avatar
              v-icon {{ item.icon }}
            v-list-tile-title {{ item.title }}
          v-list-tile(
            :key="`'menu-main-nav-'${3}`"
            @click="logout"
          )
            v-list-tile-avatar
              v-icon power_settings_new
            v-list-tile-title ME DECONNECTER
    //- rc-locale-switcher
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import RcLocaleSwitcher from '@/components/RcLocaleSwitcher/RcLocaleSwitcher.vue';

export default {
  name: 'RcToolbar',
  components: {
    RcLocaleSwitcher,
  },
  data() {
    return {
      productsOpen: false,
      mainMenu: [
        // { title: 'Destination', to: '/users', icon: 'person_pin' },
        { title: 'FICHES', to: '/sheets', icon: 'description' },
      ],
      items: [
        { title: 'MES UTILISATEURS', to: '/users', icon: 'person_pin' },
      ],
      logoUrl: require('@/assets/ambassadors_logo.svg')
    };
  },
  mounted() {
    if (!this.$store.state.app.user.touristicProvider) {
      this.mainMenu.unshift(...[
        { title: 'COMPTES', to: '/clients/prestataires', icon: 'accessibility' },
        { title: 'CONTACTS', to: '/clients/contacts', icon: 'description' },
      ]);
    }
  },
  i18nOptions: { namespaces: 'navigation' },
  computed: {
    // ...mapGetters('app', ['getDestinationName', 'getUserLogin']),
    ...mapState('app', ['logged', 'destination', 'user', 'initialized']),
    i18n() {
      return this.$i18n.i18next;
    },
    refs() {
      return this.$refs;
    },
    productCategories() {
      return this.$store.state.app.productCategories;
    },
  },
  methods: {
    toggle() {
      this.productsOpen = !this.productsOpen
    },
    close() {
      this.productsOpen = false;
    },
    goToProduct(productId) {
      this.$router.push({ name: 'product_detail', params: { productId }});
      this.productsOpen = false;
    },
    logout() {
      document.cookie = 'SESSIONID=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
      document.cookie = 'SESSIONID=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/v2/erp';
      const scr = document.createElement('script');
      if (window.location.host === 'user.studio.rc-preprod.com') {
        scr.src = 'https://connect.studio.rc-check.com/oauth/v2/logout?redirect=/';
      } else {
        scr.src = 'https://connect.studio.raccourci.fr/oauth/v2/logout?redirect=/';
      }
      document.body.appendChild(scr);
      setTimeout(() => {
        this.$router.push('/login');
      }, 1000);
    }
  },
};
</script>

<style lang="scss">
.main-menu-dropdown {
  transform: translateX(12px);
}
.main-nav {
  .v-toolbar__content {
    height: 74px!important;
  }
  z-index: 9;
  .selected-menu-item {
    position: relative;
  }
  .selected-menu-item:after {
    content: ' ';
    height: 0;
    width: 0;
    left: 50%;
    position: absolute;
    transform: translateX(-50%);
    margin: auto;
    border-top: solid 16px var(--primary);
    border-left: solid 22px transparent;
    border-right: solid 22px transparent;
  }
  .v-toolbar__content {
    padding-left: 12px;
    padding-right: 0;
  }
  .main-menu-block {
    &:not(.selected-menu-item) {
      i {
        transition: none;
        color: black;
      }
    }
    &:not(.selected-menu-item):hover, &.product-open {
      background-color: #4083AE!important;
      i {
        color: white!important;
      }
      color: white!important;
    }
  }
  .products-menu-block {
    border-top: 1px solid grey!important;
    border-bottom: 1px solid grey!important;
    position: fixed;
    width: 100vw;
    left: 0;
    top: var(--main-menu-height);
  }
}
</style>
